<template>
    <div class="form-horizontal">
        <div class="form-group">
            <label for="client-admin-options" class="col-xs-12 col-md-4 control-label">{{ $t('components.appointment.associate_user') }}</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" id="client-admin-options" name="client-admin-options" v-model="newAppointment.client_admin">
                    <option v-for="clientAdmin in clientsAdminAvailable" v-bind:key="clientAdmin.id" :value="clientAdmin.id">
                        {{clientAdmin.first_name}} {{clientAdmin.last_name}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <label for="appointment_is_online" class="col-xs-12 col-md-4 control-label"></label>
            <div class="col-xs-12 col-md-8">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" id="appointment_is_online" name="appointment_is_online" v-model="newAppointment.is_online"> {{ $t('components.appointment.appointments_online') }}
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group" v-for="(date, index) in newAppointment.date" v-bind:key="index">
            <label for="appointment_date" class="col-xs-12 col-md-4 control-label"> {{ $t('components.appointment.add_select_date', {number: (index + 1)}) }}</label>
            <div class="col-xs-12 col-md-8 has-feedback" >
                <Datetime id="appointment_date"
                          type="datetime"
                          :value-zone="TIMEZONE_DEFAULT"
                          :zone="TIMEZONE_DEFAULT"
                          v-model="newAppointment.date[index]"
                          :phrases="{ok: $t('common.time.choose_datetime'), cancel: $t('common.time.cancel_datetime')}"
                          input-class="form-control"></Datetime>
                <span class="glyphicon glyphicon-calendar form-control-feedback" aria-hidden="true"></span>
            </div>
        </div>
    </div>
</template>

<script>
    import {Datetime} from "vue-datetime";
    import 'vue-datetime/dist/vue-datetime.css'
    import {getAllClientAdmin} from "../../api";
    import {moveUpDatetimePopup} from "@/common/utils";
    import {TIMEZONE_DEFAULT} from "../../common/constants";
    import {StorageHelper} from "../../common/storageHelper";

    export default {
        name: "AppointmentForm",
        components: {Datetime},
        props: {
            TIMEZONE_DEFAULT: StorageHelper.getUser().timezone || TIMEZONE_DEFAULT,
            newAppointmentProp: {
                type: Object,
                required: true
            },
            appointmentCount: {
                type: Number,
                required: true
            }
        },
        data: () => {
            return {
                clientsAdminAvailable: [],
                newAppointment: {
                    date: [],
                    client_admin: null,
                    is_online: false,
                    notify: true,
                    location: null,

                }
            }
        },
        async mounted() {
            this.newAppointment = this.newAppointmentProp;
            this.clientsAdminAvailable = await getAllClientAdmin();
        },
        watch: {
            appointmentCount: function(newVal) {
                this.newAppointment.date = [];
                let date = new Date();
                date.setDate(date.getDate() + 1);
                date.setHours(12);
                date.setMinutes(0);

                for (let i = 0; i < newVal; i++) {
                    this.newAppointment.date.push(date.toISOString());
                }
            },
            newAppointmentProp: function(newVal) {
                this.newAppointment = newVal;
            },
            clientsAdminAvailable: function(newVal) {
                if (newVal.length > 0) {
                    this.newAppointment.client_admin = newVal[0].id
                }
            },
            newAppointment: {
                handler(newVal) {
                    this.$emit('change', newVal)
                    moveUpDatetimePopup()
                },
                deep: true,
            }
        }
    }
</script>
